export default __webpack_public_path__ + "static/media/SMG.8fa193af.svg";